import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Header from "../../Components/Header";
import useGetChatsActiveApi from "../../Global/Api/Messaging/getChatsApi";
import useGetNewChatsApi from "../../Global/Api/Messaging/getNewChatsApi";
import useConversationJob from "../../Global/Api/Messaging/createNewChatApi";
import useGetMessagingApi from "../../Global/Api/Messaging/getMessagingApi";
import useSendMessage from "../../Global/Api/Messaging/sendMessageApi";
import showToast from "../../Global/Hooks/toast";
import { useDebounce } from "../../Global/Hooks/useDebounce";
import {
  clearMessagesData,
  setChats,
  setReadMessage,
  setUserData,
  updateMinusTotalUnreadMessage,
} from "../../Store/Slice/messagingSlice";
import { setLoader } from "../../Store/Slice/techsbookSlice";
import AssetPreviewModal from "./components/AssetPreviewModal";
import ChatsSidebar from "./components/ChatsSidebar";
import ConversationHeader from "./components/ConversationHeader";
import MessageComposer from "./components/MessageComposer";
import MessageList from "./components/MessageList";
import NewChatPanel from "./components/NewChatPanel";
import "./index.scss";

export default function Messaging() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [searchValueNewChat, setSearchValueNewChat] = useState("");
  const [tabs, setTabs] = useState(false);
  const [messageValue, setMessageValue] = useState("");
  const [showDrop, setShowDrop] = useState(false);
  const [showAddMessage, setShowAddMessage] = useState(false);
  const firstLoadMessage = useRef(true);
  const getChats = useGetChatsActiveApi();
  const getNewChats = useGetNewChatsApi();
  const getMessaging = useGetMessagingApi();
  const conversationJob = useConversationJob();
  const sendMessage = useSendMessage();
  const elementRef = useRef(null);
  const targetRef = useRef(null);
  const newChatsRef = useRef(null);
  const [ifOffline, setIfOffline] = useState(false);
  const [pageChats, setPageChats] = useState(0);
  const [pageNewChats, setPageNewChats] = useState(0);
  const [assetsModal, setAssetsModal] = useState(null);
  const {
    chatsActive,
    chatsNewInfo,
    userData,
    messages,
    pageInfoChats,
    updatedNewChats,
  } = useSelector((state) => state?.rootReducer.messagingSlice);
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );

  const [editText, setEditText] = useState("");
  const debouncedSearchNewChatsValue = useDebounce(searchValueNewChat, 300);

  const resetSelectedUser = () => {
    dispatch(setUserData({ is_online: false }));
    localStorage.removeItem("userDataId");
  };

  const handleEditClick = (e, chat) => {
    e.stopPropagation();
    const newArr = chatsActive?.map((item) => {
      if (chat?.id === item?.id) {
        return { ...item, isEditing: true };
      }
      return item;
    });
    dispatch(setChats(newArr));
    setEditText(chat.name);
  };
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setEditText(newValue);
  };

  const handleEnterPress = async (e, chat) => {
    e.stopPropagation();

    const newArr = chatsActive?.map((item) => {
      if (chat?.id === item?.id) {
        return { ...item, isEditing: false };
      }
      return item;
    });
    dispatch(setChats(newArr));
    await getChats.updateName({ params: chat?.id, body: { title: editText } });
    if (tabs) {
      await getChats.get({ page: 1, status: "completed" });
      dispatch(setUserData({ ...userData, name: editText }));
    } else {
      await getChats.get({ page: 1, status: "active" });
    }
    setEditText("");
  };

  const handleInputClick = (event) => {
    if (tabs) {
      if (
        !event.target.closest(".edit-input") !== null ||
        (!event.target.closest(".hide-input") !== null &&
          !event.target.closest(".hide-input") !== null)
      ) {
        let newArr = chatsActive?.map((item) => ({
          ...item,
          isEditing: false,
        }));
        dispatch(setChats(newArr));
        setEditText("");
      }
    }
  };

  const offlineHandler = (bool) => {
    setIfOffline(bool);
  };

  useEffect(() => {
    const handleOffline = () => offlineHandler(true);
    const handleOnline = () => offlineHandler(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    getChats.get({ page: pageChats + 1, status: "active" });

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tabs) {
      getChats.get({ page: 1, status: "completed" });
    } else {
      getChats.get({ page: 1, status: "active" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs]);

  useEffect(() => {
    setPageChats(pageInfoChats?.page);
  }, [pageInfoChats]);

  useEffect(() => {
    setPageNewChats(chatsNewInfo?.page);
  }, [chatsNewInfo]);

  useEffect(() => {
    const targetBlock = targetRef.current;
    targetBlock?.addEventListener("scroll", handleScroll);

    // Очистка обработчика события при размонтировании компонента
    return () => {
      targetBlock?.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfoChats, pageChats]);

  useEffect(() => {
    const targetBlock = newChatsRef.current;
    targetBlock?.addEventListener("scroll", handleScrollNewChats);

    // Очистка обработчика события при размонтировании компонента
    return () => {
      targetBlock?.removeEventListener("scroll", handleScrollNewChats);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatsNewInfo?.totalPage, pageNewChats]);

  useEffect(() => {
    const targetBlockTop = elementRef.current;
    targetBlockTop?.addEventListener("scroll", handleScrollTop);

    // Очистка обработчика события при размонтировании компонента
    return () => {
      targetBlockTop?.removeEventListener("scroll", handleScrollTop);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages?.page]);

  useEffect(() => {
    const handleWindowClick = (e) => {
      if (
        e.target.closest(".messaging__chat-drop") === null &&
        e.target.closest(".messaging__chat-image") === null
      ) {
        setShowDrop(false);
      }
    };

    window.addEventListener("click", handleWindowClick);

    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  }, [location]);

  const handleEscapeKeyPress = (event) => {
    if (event.key === "Escape") {
      if (assetsModal === null) {
        dispatch(setUserData({ is_online: false }));
        localStorage.removeItem("userDataId");
      } else {
        setAssetsModal(null);
      }
    } else {
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEscapeKeyPress);
    return () => {
      window.removeEventListener("keydown", handleEscapeKeyPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsModal]);

  useEffect(() => {
    if (firstLoadMessage.current && messages?.messages.length > 0) {
      if (elementRef.current) {
        elementRef.current.scrollTop = elementRef.current.scrollHeight;
        firstLoadMessage.current = false;
      }
    } else if (elementRef.current) {
      elementRef.current.scrollTop =
        elementRef.current.scrollHeight / messages?.page;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages?.messages]);

  useEffect(() => {
    if (tabs) {
      getChats.search({ status: "completed", search: searchValue });
    } else {
      getChats.search({ status: "active", search: searchValue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, tabs]);

  useEffect(() => {
    if (debouncedSearchNewChatsValue) {
      getNewChats.get({ page: 1, search: debouncedSearchNewChatsValue });
    } else {
      getNewChats.get({ page: 1 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchNewChatsValue]);

  const handleScroll = () => {
    const targetBlock = targetRef?.current;
    const scrolledHeight = targetBlock?.scrollTop + targetBlock?.clientHeight;
    const totalHeight = targetBlock?.scrollHeight;

    if (
      scrolledHeight >= totalHeight - 5 &&
      pageInfoChats?.page < pageInfoChats?.totalPage
    ) {
      getChats.get({
        page: pageChats + 1,
        status: tabs ? "completed" : "active",
      });
    }
  };

  const handleScrollNewChats = () => {
    const targetBlock = newChatsRef?.current;
    const scrolledHeight = targetBlock?.scrollTop + targetBlock?.clientHeight;
    const totalHeight = targetBlock?.scrollHeight;

    if (
      scrolledHeight >= totalHeight - 5 &&
      chatsNewInfo?.page < chatsNewInfo?.totalPage
    ) {
      getNewChats.get({
        page: pageNewChats + 1,
      });
    }
  };

  const handleScrollTop = () => {
    const targetBlockTop = elementRef?.current;
    if (
      targetBlockTop?.scrollTop === 0 &&
      messages?.page < messages?.totalItems / 30
    ) {
      getMessaging.get(userData?.id, messages?.page + 1);
    }
  };

  const handleChatSelect = (event, item) => {
    dispatch(setUserData(item));
    localStorage.setItem("userDataId", item?.id);
    getMessaging.get(item?.id);
    firstLoadMessage.current = true;
    dispatch(clearMessagesData());
    dispatch(updateMinusTotalUnreadMessage(item?.unread_messages_count));
    dispatch(setReadMessage({ id: item?.id }));
    handleInputClick(event);
  };

  const handleShowAddMessage = () => {
    getNewChats.get({ page: 1 });
    setShowAddMessage(true);
    resetSelectedUser();
  };

  const handleTabChange = (value) => {
    setTabs(value);
    resetSelectedUser();
    setSearchValue("");
  };

  const handleNewChatSelect = (item) => {
    dispatch(setUserData(item));
    setShowAddMessage(false);
    dispatch(clearMessagesData());
    conversationJob.create(item?.id);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const body = {
        content: messageValue,
        userData: userData,
      };
      if (ifOffline) {
        showToast("No internet", "error");
      } else {
        if (messageValue.length > 0) {
          sendMessage.create(body, targetRef);
          setMessageValue("");
        }
      }
    }
  };

  const submitMessage = () => {
    if (ifOffline) {
      showToast("No internet", "error");
    } else {
      if (messageValue.length > 0) {
        const body = {
          content: messageValue,
          userData: userData,
        };
        sendMessage.create(body, targetRef);
        setMessageValue("");
      }
    }
  };

  const handleImageUpload = (event) => {
    if (ifOffline) {
      showToast("No internet", "error");
      return;
    }

    sendMessage.sendFiles(event, userData);
    setShowDrop(false);
  };

  const handleFileUpload = (event) => {
    if (ifOffline) {
      showToast("No internet", "error");
      return;
    }

    sendMessage.sendFiles(event, userData, "file");
    setShowDrop(false);
  };

  const openAssetPreview = (asset) => {
    setAssetsModal({ ...asset, show: true });
  };

  const downloadMessageFile = (file) => {
    const link = document.createElement("a");
    link.href = file?.full_path;
    const lastDotIndex = file?.path?.lastIndexOf(".");
    const extension = file?.path?.substring(lastDotIndex + 1);
    link.setAttribute("download", `file.${extension}`);
    link.setAttribute("target", `_blank`);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function downloadFile(url) {
    dispatch(setLoader(true));
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          dispatch(setLoader(false));
          showToast(`Network response was not ok`, "error");
          throw new Error(`Network response was not ok`);
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement(`a`);
        a.href = blobUrl;
        a.download = `downloaded-file`;
        a.style.display = `none`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
        dispatch(setLoader(false));
      })
      .catch((error) => {
        showToast(`Error:`, error);
        dispatch(setLoader(false));
      });
  }

  return (
    <>
      <Header title={"Messaging"} />
      <div className="messaging">
        <div className="messaging__wrapper">
          <AssetPreviewModal
            assetsModal={assetsModal}
            onClose={() => setAssetsModal(null)}
            onDownload={downloadFile}
          />
          {!showAddMessage ? (
            <ChatsSidebar
              chatsActive={chatsActive}
              userData={userData}
              tabs={tabs}
              searchValue={searchValue}
              targetRef={targetRef}
              editText={editText}
              onShowAddMessage={handleShowAddMessage}
              onTabChange={handleTabChange}
              onSearchChange={setSearchValue}
              onChatSelect={handleChatSelect}
              onEditClick={handleEditClick}
              onEditChange={handleInputChange}
              onEditSave={handleEnterPress}
            />
          ) : (
            <NewChatPanel
              showAddMessage={showAddMessage}
              newChatsRef={newChatsRef}
              updatedNewChats={updatedNewChats}
              userData={userData}
              onBack={() => setShowAddMessage(false)}
              onSearchChange={setSearchValueNewChat}
              onNewChatSelect={handleNewChatSelect}
            />
          )}
          <div className="messaging__right">
            <div className="messaging__chat">
              <ConversationHeader
                userData={userData}
                onJobLinkClick={() => {
                  localStorage.setItem("jobId", userData?.job_title);
                }}
              />
              <MessageList
                messages={messages}
                userData={userData}
                accountIndex={accountIndex}
                elementRef={elementRef}
                onAssetOpen={openAssetPreview}
                onFileDownload={downloadMessageFile}
              />
              <MessageComposer
                userData={userData}
                messageValue={messageValue}
                showDrop={showDrop}
                onToggleDrop={() => setShowDrop(!showDrop)}
                onMessageChange={setMessageValue}
                onKeyPress={handleKeyPress}
                onSubmit={submitMessage}
                onImageUpload={handleImageUpload}
                onFileUpload={handleFileUpload}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}